import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { ItemMonitoramentoDetalhado } from './item-monitoramento-detalhado.model';
import { ItemMonitoramento } from './item-monitoramento.model';

export class InternetMonitoramento {

  googleComSsl: ItemMonitoramento;
  googleSemSsl: ItemMonitoramento;

  public static getAtivo(internet: InternetMonitoramento): AtivoMonitoramentoDetalhado {
    return new AtivoMonitoramentoDetalhado('Internet', [
      new ItemMonitoramentoDetalhado('Google com SSL', internet.googleComSsl),
      new ItemMonitoramentoDetalhado('Google sem SSL', internet.googleSemSsl)
    ]);
  }
}
